<template>
  <div v-role="roles">
    <loading  v-if="isLoading"/>
   
    <v-data-table :headers="headers" :items="turmas" :sort-desc="true" class="elevation-1" :search="search">
      <!--========== CAMPOS ACIMA DA TABELA E FORMULÁRIO CADASTRAR TURMA ==========-->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-row style="align-items: center; text-align: center;">
            <v-col cols="3" sm="3" md="3">
              <v-toolbar-title>
                Turma(s) da
                <span v-if="idclasse === 1">10ª classe</span>
                <span v-if="idclasse === 2">11ª classe</span>
                <span v-if="idclasse === 3">12ª classe</span>
                <span v-if="idclasse === 4">13ª classe</span>
              </v-toolbar-title>
            </v-col>

            <v-col cols="3" sm="3" md="3">
              <v-select
                style="margin-top: 30px; width: 200px !important;"
                :items="Listaranoslectivo"
                v-model="anolectivoSelected"
                item-value="descricao"
                item-text="novadescricao"
                @change="FiltraAnolectivo()"
                label="Selecione o Ano lectivo"
                return-object
              ></v-select>
            </v-col>

            <v-col cols="3" sm="3" md="3" style="display: flex; align-items: center;">
              <v-text-field style="width: 250px !important;" v-model="search" append-icon="search" label="Pesquisar" single-line hide-details></v-text-field>
              <v-btn v-if="search" @click="initializeturmasAll(search)" text icon color="green"><v-icon>cached</v-icon></v-btn>
            </v-col>

            <v-col cols="3" sm="3" md="3">
              <v-btn class="mx-2" fab dark color="primary" @click="dialog = true;">
                <v-icon dark>add</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <!--========== FIM CAMPOS ACIMA DA TABELA ==========-->

          <!--========== FORMULÁRIO CADSTRAR NOVA TURMA ==========-->
          <v-dialog v-model="dialog" max-width="500px">
            <v-card>
              <div v-if="$store.state.hasMessage || turmaExistente" :class="$store.state.classMessage">
                {{ $store.state.textMessage }}
              </div>

              <v-card-title>
                <span class="headline">{{ formTitle }} -</span>
                <span v-if="idclasse === 1">10ª classe</span>
                <span v-if="idclasse === 2">11ª classe</span>
                <span v-if="idclasse === 3">12ª classe</span>
                <span v-if="idclasse === 4">13ª classe</span>
              </v-card-title>

              <v-card-text>
                <v-container>
                  <v-form ref="form" v-model="formValid" lazy-validation>
                    <v-row>
                      <v-col cols="12" sm="12" md="12">
                        <span v-if=" sala && flag_curso && editedItem.periodo.value && false" ref="myid">
                          {{flag_curso.trim().toUpperCase().substring(0, 3).concat("-").concat("SALA " + sala.padStart(2, "0") + "-").concat(
                            editedItem.periodo.value + "-" + anolectivoSelected)
                          }}
                        </span>
                      </v-col>

                      <v-col cols="12" sm="12" md="12">
                        <v-combobox v-model="editedItem.idCurso" item-text="descricao" @change="createdTurmaflag_description" :items="cursos" chips label="Curso"></v-combobox>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field :rules="notaRules" v-model="sala" label="Sala" @change="concatTurmaAnolectivo(1)"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field :rules="notaRules" v-model="capacidade" label="Capacidade"></v-text-field>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-combobox v-model="editedItem.periodo" item-value="value" item-text="descricao" :items="periodos" chips @change="concatTurmaAnolectivo(1)" label="Periodo"></v-combobox>
                      </v-col>

                      <v-col cols="12" sm="12" md="6">
                        <v-text-field v-model="editedItem.descricao" :rules="[(v) => !!v || 'campo obrigatório.']" :disabled="!disabledTurmaDescricao" label="Descrição da Turma"></v-text-field>
                      </v-col>
                    </v-row>
                  </v-form>
                </v-container>
              </v-card-text>

              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn class="cancelartBtn" color="white darken-1" text @click="close">Cancelar</v-btn>
                <v-btn class="salvartBtn" color="white darken-1" text :loading="loading2" :disabled=" !(formValid && sala && flag_curso && editedItem.periodo.value && !turmaExistente)" @click="save">
                  Salvar
                  <template v-slot:loader>
                    <span>Processando...</span>
                  </template>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
          <!--========== FIM FORMULÁRIO CADSTRAR NOVA TURMA ==========-->
        </v-toolbar>
      </template>
      <!--========== FIM CAMPOS ACIMA DA TABELA E FORMULÁRIO CADASTRAR TURMA ==========-->


      <template v-slot:item.index="{ item }">
        <span>{{ turmas.indexOf(item) + 1 }}</span>
      </template>

      <!--======= BOTÃO MENU (ACTIONS) ================-->
      <template v-slot:item.action="{ item }">
        <v-menu bottom origin="center center" transition="scale-transition">
          <template v-slot:activator="{ on }">
            <v-btn fab dark color="teal" style="color: white" v-on="on">
              <v-icon>menu</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-item @click="ListagemEstudantes(item)">
              <v-icon class="mr-2" style="color: #808080">receipt</v-icon>
              <span> Lista de Estudantes</span>
            </v-list-item>

            <v-list-item v-if="isIlha" @click="mapaavaliacaocontinua(item)">
              <v-icon class="mr-2" style="color: #808080">insert_drive_file</v-icon>
              <span> Mapa de controlo das avaliações contínuas</span>
            </v-list-item>

            <v-list-item v-if="isIlha" @click="mapacontrolotrimestral(item)">
              <v-icon class="mr-2" style="color: #808080">insert_drive_file</v-icon>
              <span> Mapa de controlo Trimestral </span>
            </v-list-item>

            <v-list-item @click="transitacao(item)">
              <v-icon small style="color: #808080" class="mr-2" v-if="role === 'ROLE_ADM'">cached</v-icon>
              <span style="color: black"> Transitação</span>
            </v-list-item>

            <v-list-item @click="deleteItem(item)" v-if="!item.quantalunos || item.quantalunos < 1">
              <v-icon small style="color: red" class="mr-2">delete</v-icon>
              <span style="color: red"> Eliminar</span>
            </v-list-item>

            <v-list-item v-if="role === 'ROLE_ADM'" @click="showAdicionarDisciplinas(item)">
              <v-icon small style="color: #808080" class="mr-2">add</v-icon>
              <span> Adicionar Disciplina</span>
            </v-list-item>

            <v-list-item @click="mostrarAumentarCapacidade(item)">
              <v-icon small style="color: #808080" class="mr-2">settings</v-icon>
              <span> Editar Capacidade/ Descrição </span>
            </v-list-item>

            <v-list-item v-if="(isIlha || isNascer) && isintegrado" @click="cartaoEstudante(item)">
              <v-icon class="mr-2" style="color: #808080">print</v-icon>
              <span> Cartão de Estudante</span>
            </v-list-item>

            <v-list-item @click="boletimTurma(item)">
              <v-icon class="mr-2" style="color: #808080">list</v-icon>
              <span> Boletim</span>
            </v-list-item
            >
            <v-list-item @click="minipauta(item)">
              <v-icon class="mr-2" style="color: #808080">list</v-icon>
              <span> Mini pauta </span>
            </v-list-item>

            <v-list-item @click="pautageral(item)">
              <v-icon class="mr-2" style="color: #808080">list</v-icon>
              <span> Pauta Geral </span>
            </v-list-item>
          </v-list>
        </v-menu>
      </template>
      <template v-slot:no-data> Dados não encontrados! </template>
    </v-data-table>
    <!--======= FIM BOTÃO MENU (ACTIONS) ================-->

    <!-- =============== CARD ADICIONAR DISCIPLINA NA PAUTA ==================== -->
    <template>
      <v-row justify="center">
        <v-dialog v-model="dialogoPauta" persistent max-width="600px">
          <v-card>
            <h4 class="cardTitle"><span> Adicionar disciplina na Pauta </span></h4>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Turma" v-model="editedItemPauta.turmadescricao" :disabled="true"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Classe" required v-model="editedItemPauta.classe_descricao" :disabled="true"></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field label="Anolectivo" v-model="editedItemPauta.anoLectivo" required :disabled="true"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="8">
                    <v-combobox :items="disciplinas_" item-text="disciplina" v-model="editedItemPauta.disciplina" label="Selecione a disciplina" return-object required></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="cancelartBtn" color="white darken-1" text @click="dialogoPauta = false"> Cancelar</v-btn>
              <v-btn class="salvartBtn" color="white darken-1" text @click="AdicionarDisciplinaPauta()"> Adicionar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!-- =============== FIM CARD ADICIONAR DISCIPLINA NA PAUTA ==================== -->


    <!-- =============== CARD AUMENTAR CAPACIDADE DA TURMA ==================== -->
    <!-- <template>
      <v-row justify="center">
        <v-dialog v-model="dialogoPauta" persistent max-width="600px">
          <v-card>
            <h4 class="cardTitle"><span> Adicionar disciplina na Pauta </span></h4>
            <v-card-text>
              <v-container>
                <v-row>
                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Turma" v-model="editedItemPauta.turmadescricao" :disabled="true"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="6" md="4">
                    <v-text-field label="Classe" required v-model="editedItemPauta.classe_descricao" :disabled="true"></v-text-field>
                  </v-col>

                  <v-col cols="4">
                    <v-text-field label="Anolectivo" v-model="editedItemPauta.anoLectivo" required :disabled="true"></v-text-field>
                  </v-col>

                  <v-col cols="12" sm="8">
                    <v-combobox :items="disciplinas_" item-text="disciplina" v-model="editedItemPauta.disciplina" label="Selecione a disciplina" return-object required></v-combobox>
                  </v-col>
                </v-row>
              </v-container>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn class="cancelartBtn" color="white darken-1" text @click="dialogoPauta = false"> Cancelar</v-btn>
              <v-btn class="salvartBtn" color="white darken-1" text @click="AdicionarDisciplinaPauta()"> Adicionar </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template> -->
    <!-- =============== FIM CARD AUMENTAR CAPACIDADE DA TURMA ==================== -->

    <!-- =============== COMPONENTES EXTERNOS USADOS NA PÁGINA ==================== -->
    <mapaavaliacao v-if="$store.state.showDialogGuia.mapacontrolavaliacaocontinua.componente"/>
    <mapaControloTrimestral :estudantes="[]" v-if="$store.state.showDialogGuia.mapacontroltrimestral.componente"></mapaControloTrimestral>
    <cartaoescolar v-if="$store.state.showDialogGuia.cartao" />
    <boletim v-if="$store.state.showDialogGuia.boletim" />
    <pautageral v-if="$store.state.componentepauta" />
    <!-- =============== FIM COMPONENTES EXTERNOS USADOS NA PÁGINA ==================== -->

    <!--============= CARD EDITAR CAPACIDADE ===============-->
    <template v-if="showEditarCapacidade">
      <v-row justify="center">
        <v-dialog v-model="showEditarCapacidade" persistent max-width="690">
          <v-card>
            <v-card-title class="headline"
              ><v-icon color="blue">info</v-icon>Editar capacidade da turma</v-card-title
            >
            <v-card-text>
              <v-row>
                <v-col cols="4">
                  <v-text-field
                    v-model="paramsCapacidade.descricao"
                    label="Turma"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="paramsCapacidade.curso"
                    label="Curso"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="paramsCapacidade.capacidade"
                    label="Capacidade Atual"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="paramsCapacidade.quantalunos"
                    label="Nº de estudante na turma"
                    disabled
                  ></v-text-field>
                </v-col>
                <v-col cols="4">
                  <v-text-field
                    v-model="paramsCapacidade.novaCapacidade"
                    label="Nova capacidade"
                  ></v-text-field>
                </v-col>
                 <v-col cols="4">
                  <v-text-field
                    v-model="paramsCapacidade.novadescricao"
                    
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="red darken-1" text @click="fecharComponente()">
                Cancelar
              </v-btn>
              <v-btn color="green darken-1" text @click="finalizar()">
                Finalizar
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-row>
    </template>
    <!--============ FIM CARD EDITAR CAPACIDADE ================-->
  </div>
</template>
<script>
import axios from "../../../plugins/axios";
import Swal from "sweetalert2";
const ls = require("local-storage");
import loading from "../../../components/loading.vue";
import axiosNest from '../../../plugins/axios_nest';
import utilitarios from "../../../plugins/utilitarios";
export default {
  components: {
    mapaavaliacao: () =>import("../../../views/tec-ped/componentes/mapacontrolavaliacao.vue"),
    mapaControloTrimestral: () => import("../../views/../tec-ped/componentes/mapacontrolotrimestral.vue"),
    cartaoescolar: () => import("../../../views/tec-ped/componentes/cartao.vue"),
    boletim: () => import("../../../views/tec-ped/componentes/boletimTurma.vue"),
    pautageral: () => import("../../../views/tec-ped/componentes/pauta/pautageral.vue"),
    loading,
  },
  data: () => ({
    loading2: false,
    paramsCapacidade: {
      descricao: '',
      capacidade: '',
      quantalunos: '',
      novaCapacidade: '',
      novaDescricao: '',
      pkTurma: '',
      curso: ''
    },
    defaultparamsCapacidade: {
      descricao: '',
      capacidade: '',
      quantalunos: '',
      novaCapacidade: '',
      pkTurma: '',
      curso: ''
    },
    showEditarCapacidade: false,
    url: ls.get("urlReport"),
    instituicao: ls.get("i_id"),
    turmasClasseAnolectivo: [],
    overlay: false,
    roles: "func",
    text: "",
    flag_curso: "",
    dialogoPauta: false,
    dialogoAumentarCapacidade: false,
    formValid: true,
    isLoading: false,
    Listaranoslectivo: [],
    estudantes: [],
    disciplinas_: [],
    alunosTurma: [],
    flag_periodo: "",
    flag_sala: "",
    flag_class: "",
    progresso: false,
    anolectivoSelected: null,
    sala: "",
    search: "",
    cursos: [],
    notaRules: [
      (v) => (v >= 0 && v <= 100) || "Valor da sala invalido.",
      (v) => !!v || "Campo obrigatório.",
      (v) => !isNaN(v) || "Digite um número.",
      (v) => v ? v.length <= 2 || "Valor inválido" : "Campo obrigatório.",
    ],
    periodos: [
      { descricao: "Manhã", value: "M", id: 1 },
      { descricao: "Tarde", value: "T", id: 2 },
      { descricao: 'Noite', value: 'N', id: 3 }
    ],
    turmas: [],
    dialog: false,
    capacidade: null,
    headers: [
      { text: '#', value: 'index' },
      { text: "descricao", align: "left", sortable: false, value: "turmadescricao",},
      { text: "Periodo", value: "periodo" },
      { text: "Curso", value: "curso" },
      { text: "Classe", value: "classe_descricao" },
      { text: "Capacidade", value: "capacidade" },
      { text: "Numero de Alunos", value: "quantalunos" },
      { text: "Modificado", value: "data_2" },
      { text: "Actions", value: "action", sortable: false },
    ],
    editedIndex: -1,
    editedItem: {
      idCurso: { idCurso: "0", descricao: "", capacidade: "",},
      idAno_Academico: 0,
      descricao: "",
      autor: "",
      periodo: "",
      capacidade: "",
      idinstituicao: "",
    },
    defaultItem: {
      idCurso: { idCurso: "0", descricao: ""},
      idAno_Academico: 0,
      descricao: "",
      autor: "",
      periodo: "",
      idinstituicao: "",
    },
    editedItemPauta: {
      nome: "",
      turmadescricao: "",
      anoLectivo: "",
      classe_descricao: "",
      disciplina: "",
    }
  }),

  computed: {
    licencaExpirada() {
      return ls.get("licencaExpirada");
    },
    isintegrado() {
      return ls.get("isintegrado");
    },
    role() {
      return ls.get("role");
    },
    isBendizer() {
      return window.location.host.includes("bendizer.net");
    },
    isIlha() {
      return ls.get("i_id") === 24 ? 1 : 0;
    },
    isNascer() {
      return (ls.get('i_id') === 132 ? 1 : 0)
    },
    isGab() {
      return (ls.get('i_id') === 106 ? 1 : 0)
    },
    formTitle() {
      return this.editedIndex === -1 ? "Nova Turma" : "Editar Turma";
    },

    idclasse() {
      return this.$store.state.idclasse;
    },
    classeTur() {
      return this.$store.state.classeTur;
    },
    disabledTurmaDescricao() {
      return !!(
        this.editedItem.periodo &&
        this.editedItem.idCurso &&
        this.sala
      );
    },

    turmaExistente() {
      let pkTurma = this.$store.state.anolectivoSelecionado.substr(-2).concat(this.editedItem.idCurso.idCurso + "" + this.editedItem.periodo.id)
        .concat(this.sala.padStart(2, "0") + "" + this.instituicao.toString().padStart(3, "0"));
        console.log("this.turmasClasseAnolectivo2", this.turmasClasseAnolectivo)
      if (this.turmasClasseAnolectivo.filter((t) => t.pkTurma === parseInt(pkTurma)).length === 0) {
        return false;
      } else {
        this.$store.dispatch('textMessage', {msg: 'A turma já existe', classMessage: 'msgError', timeout: 3000})
        return true;
      }
    },
  },

  watch: {
    dialog(val) {
      val || this.close();
    },
  },

  created() {
    try {
      if (ls.get("role") === "ROLE_COOR") {
        this.roles = "coor";
      }
      
      if (!this.$store.state.idclasse) {
        this.$router.push("/painelClassTurma");
      }
      this.initializeCursos();
      this.initializeturmasAll();
      this.initializeAnosLectivo();
      this.initializeturmasAll_classeAnolectivo();
      this.anolectivoSelected = this.$store.state.anolectivoSelecionado;
      this.$store.state.showDialogGuia.boletim = false;
      this.$store.state.componentepauta = false;
    } catch (error) {
      Swal.fire("Informação", "<p>Erro ao inicializar a página!</p>", "error");
    }
  },

  methods: {
    mostrarAumentarCapacidade(item) {
      this.paramsCapacidade.curso = item.descricao
      this.paramsCapacidade.pkTurma = item.pkTurma
      this.paramsCapacidade.descricao = item.turmadescricao
      this.paramsCapacidade.quantalunos = item.quantalunos
      this.paramsCapacidade.capacidade = item.capacidade
      this.paramsCapacidade.novadescricao = item.turmadescricao
      this.showEditarCapacidade = true
    },

    async finalizar() {
      if (!this.paramsCapacidade.novaCapacidade) {
        Swal.fire('Informação', 'Por favor, insira a nova capacidade', 'warning');
      } else if (!/^\d+$/.test(this.paramsCapacidade.novaCapacidade)) {
        Swal.fire('Informação', 'Formato não aceite, insira um número inteiro', 'warning');
      } else {
        if (this.paramsCapacidade.quantalunos > this.paramsCapacidade.novaCapacidade) {
          Swal.fire('Informação', 'A nova capacidade não pode ser inferior ao número de estudantes já cadastrados na turma', 'warning');
        } else {
          this.isLoading = true
          try {
            let response = await axios.post('/editarCapacidadeTurma', this.paramsCapacidade)
            .then(res => res.data)

            if (response.affectedRows >= 1) {
              Swal.fire('Sucesso', 'Atualização feita com sucesso', 'success')
              this.fecharComponente()
              this.initializeturmasAll();
            }
          } catch (error) {
          Swal.fire('informação', 'Erro ao atualizar a cappacidade!', 'error')
          } finally {
            this.isLoading = false;
          }
        }
      }
    },

    fecharComponente() {
      this.showEditarCapacidade = false;
      this.paramsCapacidade = this.defaultparamsCapacidade
    },

    async cartaoEstudante(item) {
      this.isLoading = true;
      this.$store.state.objturma = item;
      this.$store.state.isloading = true;
      try {
        this.listEstudantfromPauta = await axios.get("/ListaEstudantes/" + this.$store.state.objturma.pkTurma).then((res) => res.data);
        if (this.listEstudantfromPauta.length > 0) {
          this.$store.state.alunoscard = [];
          this.listEstudantfromPauta.forEach((element) =>
            this.$store.state.alunoscard.push({
              nome: element.nome.toUpperCase(),
              matricula: element.idMatricula,
              curso: element.curso.toUpperCase(),
              turma: element.turma,
              anolectivo: element.anolectivo,
              periodo: element.periodo,
              classe: element.classe,
              sala: element.sala,
              foto: "",
              codebar: ls.get("urlFoto") + `barCode/` + element.idMatricula,
            })
          );
          this.$store.state.showDialogGuia.cartao = true;
        } else {
          this.$store.state.isloading = false;
        }
      } catch (error) {
        Swal.fire("Informação", "<p>Erro durante a operação do cartão do estudante!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    /** Turmas criadas pela instituicao e adicionadas ao sistema */
    concatTurmaAnolectivo(valor) {
      if (valor === 1) {
        this.editedItem.descricao = this.flag_curso
          .trim()
          .toUpperCase()
          .substring(0, 3)
          .concat("-")
          .concat("SALA " + this.sala.padStart(2, "0") + "-")
          .concat(this.editedItem.periodo.value + "-" + this.$store.state.novadescricaoSelecionado);
      }
    },

    createdTurmaflag_description() {
      this.flag_curso = this.editedItem.idCurso.descricao;
      this.concatTurmaAnolectivo(1);
    },

    async AdicionarDisciplinaPauta() {
      this.isLoading = true;
      try {
        let params = { editedItem: this.editedItemPauta, estudantes: this.estudantes,};
        let result = await axios.post("/add_disciplina_pautaByTurma", params).then((res) => res.data);
        if (result.affectedRows >= 1) {
          Swal.fire("Informação", "<p>Disciplina adicionada com sucesso!</p>", "success");
        } else {
          Swal.fire("Informação", "<p>Disciplina já adicionada.</p>", "warning");
        }
      } catch (error) {
        console.log(error);
        
        Swal.fire("Informação", "<p>Erro ao adicionar disciplina turma!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async showAdicionarDisciplinas(item) {
      this.estudantes = await this.ObterEstudantesTurma(item.pkTurma);
      this.editedItemPauta = Object.assign(this.editedItemPauta, item);
      this.disciplinas_ = await this.ObterDisciplinas(
        item.idCurso,
        item.idAno_Academico,
        item.pkTurma
      );
      this.dialogoPauta = true;
      // Swal.fire({
      //       title: "Adicionar disciplinas",
      //       text: "Deseja adicionar disciplinas aos estudantes da turma ?",
      //       icon: "question",
      //       showCancelButton: true,
      //       confirmButtonColor: "#3085d6",
      //       cancelButtonColor: "#d33",
      //       confirmButtonText: "Adicionar",
      //       cancelButtonText:"Cancelar",
      //       reverseButtons:true
      //     }).then(async(result) => {
      //       if (result.isConfirmed) {
      //         this.overlay = true
      //         //  let result = await this.EliminarDisciplinaAtribuida(item)
      //         //  if(result.affectedRows >= 1){
      //         //     Swal.fire('Informação','Atribuição eliminada com sucesso','success')
      //         //      const index = this.profediscinas.indexOf(item)
      //         //       this.profediscinas.splice(index, 1)
      //         //  }

      //       }
      //     });
    },

    async initializeCursos() {
      this.isLoading = true;
      try {
        this.cursos = await axiosNest.get("/curso/getCursos").then((res) => res.data);
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao carregar os cursos!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async initializeturmasAll(search) {
      this.isLoading = true;
      try {
        ///turmaFindAll-Anolectivo
        this.turmas = await axiosNest.get("/turma/getTurmaByAnolectivoClasse/" + this.$store.state.anolectivoSelecionado + "/" + this.$store.state.idclasse).then((res) => res.data);
      } catch (error) {
         
        Swal.fire("Informação", "<p>Erro ao carregar as turmas!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async initializeturmasAll_classeAnolectivo(search) {
      this.isLoading = true;
      try {
        ///turmaFindAll-Anolectivo-classe/
        this.turmasClasseAnolectivo = await axiosNest.get("turma/getTurma/" + this.$store.state.anolectivoSelecionado + "/" + this.$store.state.idclasse).then((res) => res.data);
        
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao inicializar as turmas!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    editItem(item) {
      this.editedIndex = this.turmas.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.dialog = true;
    },

    deleteItem(item) {
      confirm("Are you sure you want to delete this item?") && this.EliminaTurma(item);
    },

    async initializeAnosLectivo() {
      this.isLoading = true;
      try {
        //listarAnoLectivoAll
        this.Listaranoslectivo = await axiosNest.get("/helpers/getAnolectivo").then((res) => res.data); 

      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao carregar os anos lectivos!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async ObterEstudantesTurma(pkTurma) {
      this.isLoading = true;
      try {
        return await axios.get("/ListaEstudantes/" + pkTurma).then((res) => res.data);
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao buscar os estudantes!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async EliminaTurma(item) {
      this.isLoading = true;
      try {
        this.alunosTurma = await axios.get("/turmaFindCountPk/" + item.pkTurma).then((res) => res.data);
        if (!this.alunosTurma.length) {
          this.Eliminar(item);
          const index = this.turmas.indexOf(item);
          this.turmas.splice(index, 1);
        } else {
          Swal.fire("Informação", "<p>Está turma não pode ser eliminada!</p>", "warning");
        }
      } catch (error) {
        Swal.fire("Informação", "<p>Erro ao eliminar turma!</p>", "error");
      } finally {
        this.isLoading = false;
      }
    },

    async Eliminar(item) {
      try {
        this.msg = await axios
          .get("/EliminarTurma/" + item.pkTurma)
          .then((res) => res.data);

        this.text = this.msg;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgSucess",
          timeout: 4000,
        });
      } catch (error) {
        this.text = error;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 3000,
        });
      }
    },

    close() {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    ListagemEstudantes(item) {
      this.$store.state.objturma = item;
      ls.set("backTo", "turmacrud");
      this.$router.push("ListaAlunos");
    },

    async ObterDisciplinas(idCurso, idacademico, pkTurma) {
      return await axios
        .post("/disciplina_curso_classe", {
          idCurso: idCurso,
          idanoacademico: idacademico,
          turma: pkTurma,
        })
        .then((res) => res.data);
    },

    async FiltraAnolectivo() {
      this.$store.state.novadescricaoSelecionado =
        this.anolectivoSelected.novadescricao;
      this.$store.state.anolectivoSelecionado =
        this.anolectivoSelected.descricao;
      this.initializeturmasAll();
    },

    async save() {
      let turma = this.flag_curso.trim().toUpperCase().substring(0, 3).concat("-").concat("SALA " + this.sala.padStart(2, "0") + "-").concat(this.editedItem.periodo.value + "-" + this.$store.state.novadescricaoSelecionado);

      if (turma !== this.editedItem.descricao) {
        turma = this.editedItem.descricao.concat("-").concat("SALA " + this.sala.padStart(2, "0") + "-").concat(this.editedItem.periodo.value + "-" + this.$store.state.novadescricaoSelecionado);
      }

      this.progresso = true;
      try {
        var params = {
          idCurso: this.editedItem.idCurso.idCurso,
          idAno_Academico: this.idclasse,
          descricao: (this.isBendizer || this.isGab) ? this.editedItem.descricao : turma,
          autor: "",
          periodo: this.editedItem.periodo.descricao,
          sala: this.sala,
          capacidade: this.capacidade,
          anolectivo: this.$store.state.anolectivoSelecionado,
        };
      } catch (error) {}

      try {
        let corMensagem = "msgError";
        let msg = await axiosNest
          .post("/turma/create", params)
          .then((res) => res.data);


          console.log(msg);


        //turmaInsertOne

        //turma/create

        // this.text = msg[1].insertId
        // verificação da mensagem  de erro
        if(msg.sqlMessage) {
          if (msg.sqlMessage.includes("Duplicate")) {
            Swal.fire("Informação", "Turma já criada", "warning");
          } else
            Swal.fire(
              "Informação",
              "Ocorreu um erro ao efectuar a operação",
              "error"
            );
        } else {
          Swal.fire("Informação", "Turma criada com sucesso", "success");
          // Inserção dos dados do turma na coleção
          let v = {
            turmadescricao: this.isBendizer ? this.editedItem.descricao : turma,
            periodo: this.editedItem.periodo.descricao,
            curso: this.editedItem.idCurso.descricao,
            data_2: utilitarios.converterData(),
            pkTurma: parseInt(
              this.$store.state.anolectivoSelecionado
                .substr(-2)
                .concat(
                  this.editedItem.idCurso.idCurso +
                    "" +
                    this.editedItem.periodo.id
                )
                .concat(
                  this.sala.padStart(2, "0") +
                    "" +
                    this.instituicao.toString().padStart(3, "0")
                )
            ),
          };
          this.progresso = false;
          this.turmas.unshift(v);
          this.turmasClasseAnolectivo.unshift(v);
          this.$refs.form.resetValidation();
          this.dialog = false;
        }
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: corMensagem,
          timeout: 2000,
        });
      } catch (error) {
        this.text = error.message;
        this.$store.dispatch("textMessage", {
          msg: this.text,
          classMessage: "msgError",
          timeout: 8000,
        });
      }

      this.progresso = false;
    },
    async transitacao(item) {
      try {
        let result = await axios
          .post("/Actualizartransitacao", item)
          .then((res) => res.data);
        if (result && result.affectedRows > 0) {
          Swal.fire("Informação", "Operação realizada com sucesso", "success");
        } else {
          Swal.fire(
            "Informação",
            "Verifique se todas as notas foram lançadas",
            "warning"
          );
        }
      } catch (error) {
        Swal.fire(
          "Informação",
          "Ocorreu um erro ao realizar essa operação",
          "error"
        );
      }
    },

    async mapaavaliacaocontinua(item) {
      try {
        if (this.licencaExpirada) {
          Swal.fire(
            "Informação",
            "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
            "info"
          );
        } else {
          let alunos = await axios
            .get("/ListaEstudantes/" + item.pkTurma)
            .then((res) => res.data);
          if (alunos.length) {
            this.$store.state.disciplinaTurma = item;
            this.$store.state.minipauta = { iddisciplina: 0, notas: alunos };
            ls.set("disciplinaobj", {
              classe: item.classe_descricao,
              descricao: "",
              iddisciplina: 0,
            });
            this.$store.state.isloading = true;
            this.$store.state.showDialogGuia.mapacontrolavaliacaocontinua.componente = true;
          }
        }
      } catch (error) {
        Swal.fire({ icon: "error", title: "", text: "Ocorreu um erro" });
      }
    },
    async mapacontrolotrimestral(item) {
      try {
        if (this.licencaExpirada) {
          Swal.fire(
            "Informação",
            "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
            "info"
          );
        } else {
          this.$store.state.disciplinaTurma = item;
          this.$store.state.showDialogGuia.mapacontroltrimestral.componente = true;
        }
      } catch (error) {
        Swal.fire({ icon: "error", title: "", text: "Ocorreu um erro" });
      }
    },
    boletimTurma(item) {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        this.$store.state.objturma = item;
        this.$store.state.showDialogGuia.boletim = true;
      }
    },
    minipauta(item) {
      let turma = {
        anoLectivo: item.anoLectivo,
        idCurso: item.idCurso,
        pkTurma: item.pkTurma,
        idclasse: item.idAno_Academico,
        periodo: item.periodo,
        turma: item.turmadescricao,
        curso: item.curso,
      };

      ls.set("disciplinasDaTurma", turma);
      this.$router.push("/impressao/DisciplinaDaTurma");
    },
    pautageral(item) {
      if (this.licencaExpirada) {
        Swal.fire(
          "Informação",
          "A sua licença de utilização encontra-se expirada! Por favor, entre em contato com o administrador do sistema!",
          "info"
        );
      } else {
        if (parseInt(item.anoLectivo) >= 2020) {
          this.$store.state.objturma = item;
          this.$store.state.componentepauta = true;
        } else {
          this.$router.push("/impressao/imprimir-pauta");
        }
      }
    },
    // pautageral(item){
    //   this.$store.state.idclasse = item.idAno_Academico
    //   if (parseInt(item.anoLectivo) >= 2020) {
    //       this.$router.push('/impressao/pauta_geral')
    //     } else { this.$router.push('/impressao/imprimir-pauta') }
    // },
    // METHODO FOR VALIDATION
    validate() {
      this.$refs.form.validate();
    },
    reset() {
      this.$refs.form.reset();
    },
    resetValidation() {
      this.$refs.form.resetValidation();
    },
    //* ********************************************************************************************* */
    // END METHOD FOR VAL
  },
};
</script>
<style scoped>
.cardTitle {
  text-align: center; 
  font-size: 20px; 
  padding-top: 5px; 
  font-weight: 1;
}
.cancelartBtn {
  background-color: red;
  font-weight: bold;
}
.salvartBtn {
  background-color: green;
  font-weight: bold;
}
</style>